import React from 'react';
import PropTypes from 'prop-types';
import '../styles/Content.scss';

const Content = ({id, children}) => <div id={id} className="content">{children}</div>;

Content.propTypes = {
    id: PropTypes.string,
};

export default Content;
